import { IconType } from '../../../../../../BaseComponents/Icon/Utils/IconDefinitions';
import LamnaInHamtaUt from '../../../../BisattningJournal/Rutiner/LamnaInHamtaUt';
import { Kalender } from '../../../../Bokning/Rutiner/Kalender/Kalender';
import Planering from '../../../../Bokning/Rutiner/Planering/Components/Planering';
import BusinessDataExpandableList from '../BusinessDataExpandableList/BusinessDataExpandableList';
import BusinessDataGrid from '../BusinessDataGrid/BusinessDataGrid';
import BusinessDataList from '../BusinessDataList/BusinessDataList';
import { BusinessDataTable } from '../BusinessDataTable/BusinessDataTable';
import { IExtendedBusinessDataProps, TVisningstyp } from './BusinessDataSet';

export interface IVisningstyp {
  id: TVisningstyp;
  label: string;
  icon: IconType;
  defaultAvailable?: boolean;
  disableInCard?: boolean;
  component: React.FunctionComponent<
    React.PropsWithChildren<IExtendedBusinessDataProps>
  >;
}

export const lista: IVisningstyp = {
  id: 'lista',
  component: BusinessDataList,
  label: 'Lista',
  icon: 'list',
  defaultAvailable: true,
};

export const kort: IVisningstyp = {
  id: 'kort',
  component: BusinessDataGrid,
  label: 'Kort',
  icon: 'create_report',
  defaultAvailable: true,
  disableInCard: true,
};

/**
 * Lista med rubriker där man kan expandera fram detaljer i listan
 * Verkar inte användas och behöver ses över om den ska fungera
 */
export const expanderbarLista: IVisningstyp = {
  id: 'expanderbar lista',
  component: BusinessDataExpandableList,
  label: 'Expanderbar lista',
  icon: 'list',
};

/**
 * Tabell
 */
export const tabell: IVisningstyp = {
  id: 'tabell',
  component: BusinessDataTable,
  label: 'Tabell',
  icon: 'table_chart',
  defaultAvailable: true,
};

export const kalender: IVisningstyp = {
  id: 'kalender',
  component: Kalender as IVisningstyp['component'],
  label: 'Kalender',
  icon: 'resources_filter',
  defaultAvailable: false,
  disableInCard: true,
};

export const bisattningStart: IVisningstyp = {
  id: 'bisattningStart',
  component: LamnaInHamtaUt as IVisningstyp['component'],
  label: 'bisattningStart',
  icon: 'resources_filter',
  defaultAvailable: false,
  disableInCard: true,
};

export const planering: IVisningstyp = {
  id: 'planering',
  component: Planering,
  label: 'planering',
  icon: 'resources_filter',
  defaultAvailable: false,
  disableInCard: true,
};

export const visningstyper: IVisningstyp[] = [
  lista,
  kort,
  expanderbarLista,
  tabell,
  kalender,
  bisattningStart,
  planering,
];
